import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import WorkflowTaskModel from '../../../models/WorkflowTaskModel';
import WorkflowTaskQueryModel from '../../../models/WorkflowTaskQueryModel';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import FormatUtils from '../../../utils/FormatUtils';

const ItemRevision_tab_Workflows: React.FC<ItemRevisionProps> = ({ itemId, itemRevisionId, itemTypeId }) => {
    const [data, setData] = useState<WorkflowTaskQueryModel[]>()
    const { handleException } = useNotifications()
    const formatUtils = new FormatUtils()

    useEffect(() => {
        getTableData();
    }, [itemRevisionId]);

    function getTableData() {
        DataService.get<WorkflowTaskQueryModel[]>('api/v1/WorkflowTasks/ByItemRevision?itemRevisionId=' + itemRevisionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function getStatusColor(rowData: WorkflowTaskQueryModel, colInfo: IColInfo): string | undefined {
        const now = new Date(Date.now())
        const dueOn = formatUtils.dateFromString(rowData.dueOn);
        const completedOn = rowData.completedOn
            ? formatUtils.dateFromString(rowData.completedOn)
            : undefined;

        if (dueOn === undefined || dueOn >= now || (completedOn && completedOn <= dueOn))
            return 'Green';

        return 'red';
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { getCellBackgroundColor: getStatusColor, sort: false, width: 5 },
        { title: 'Workflow', dataProp: 'workflow', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Sub-Items', dataProp: 'itemRevisionColors', dataType: 'workflowItemRevisions', sort: false },
        { title: 'Step', dataProp: 'workflowStep', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Task', dataProp: 'task', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Category', dataProp: 'taskCategory', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Assigned on', dataProp: 'assignedOn', dataType: 'datetime', sort: 'desc' },
        { title: 'Assigned to', dataProp: 'assignedToUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Due on', dataProp: 'dueOn', dataType: 'datetime' },
        { title: 'Completed on', dataProp: 'completedOn', dataType: 'datetime' },
        { title: 'Completed by', dataProp: 'completedByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Chosen Action', dataProp: 'chosenWorkflowAction', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Next Action', dataProp: 'nextAction', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Comments', dataProp: 'comments', filterInfo: { filterType: 'Textbox' } },
        { title: 'Workflow status', dataProp: 'workflowStatus', filterInfo: { filterType: 'CheckboxList' } },
    ];

    return (
        <>
            <DataTable
                name='dtItemRevisionWorkflows'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Task'
                navigateUrl='/plm/Workflow/task/'
            />
        </>
    );
}
export default ItemRevision_tab_Workflows;